<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <v-row no-gutters>
        <v-col class="pt-0" cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0 mt-3">
                  <span class="grey--text">Nama Kepala Sekolah</span>
                  <div class="body-1">{{ $getDeepObj(detail, '1.ptk.data.nama') }}</div>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0 mt-2">
            <v-list-item-content class="py-0">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0 mt-3">
                  <span class="grey--text">Satuan Pendidikan / Sekolah</span>
                  <div class="body-1">{{ $getDeepObj(detail, '1.sekolah.data.nama') }}</div>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col class="pt-0" cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0 mt-3">
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="2">
                      <span class="grey--text mb-1">IHT 1</span>
                      <div class="mt-1">
                        <v-chip
                          :class="[$getDeepObj(detail, '1.k_verval_psp') > 1 ? 'green' : 'grey', 'white--text']"
                          small
                        >
                          {{ $getDeepObj(detail, '1.k_verval_psp') > 1 ? 'Sudah' : 'Belum' }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <span class="grey--text mb-1">IHT 2</span>
                      <div class="mt-1">
                        <v-chip
                          :class="[$getDeepObj(detail, '2.k_verval_psp') > 1 ? 'green' : 'grey', 'white--text']"
                          small
                        >
                          {{ $getDeepObj(detail, '2.k_verval_psp') > 1 ? 'Sudah' : 'Belum' }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <span class="grey--text mb-1">IHT 3</span>
                      <div class="mt-1">
                        <v-chip
                          :class="[$getDeepObj(detail, '3.k_verval_psp') > 1 ? 'green' : 'grey', 'white--text']"
                          small
                        >
                          {{ $getDeepObj(detail, '3.k_verval_psp') > 1 ? 'Sudah' : 'Belum' }}
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0 mt-2">
            <v-list-item-content class="py-0">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0 mt-3">
                  <span class="grey--text">Kota / Kabupaten Satuan Pendidikan / Sekolah</span>
                  <div class="body-1">{{ $getDeepObj(detail, '1.sekolah.data.m_kota.data.keterangan') }}</div>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-divider class="my-4" />
      <v-alert border="left" colored-border color="primary" class="py-0">
        <h3 class="py-1">Berikut Detil Laporan Berkala IHT</h3>
        Pilih salah satu untuk melihat detil dari Laporan Berkala IHT
        <v-row no-gutters>
          <template v-for="iht in mLaporan">
            <v-col :key="iht.value" cols="12" md="4" sm="12">
              <v-card
                outlined
                :dark="kLaporan === iht.value"
                :color="kLaporan === iht.value ? 'green' : ''"
                class="ma-1"
                style="border-radius: 5pt"
              >
                <v-list-item @click="onSelectLaporan(iht.value)">
                  <v-list-item-content>
                    <div>
                      <v-icon left large> {{ iht.icon }} </v-icon>{{ iht.text }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-alert>
      <v-list-item class="px-0" v-if="kLaporan">
        <v-list-item-content class="mt-3" v-if="$getDeepObj(detail, `${kLaporan}.k_verval_psp`) > 1">
          <template v-if="Number(kLaporan === 3)">
            <v-row class="justify-center">
              <v-col v-for="(child, c) in mLaporan[2].children" :key="c" cols="12" md="2" sm="12" class="pa-0">
                <v-card
                  outlined
                  :dark="kChild === Number(c)"
                  :color="kChild === Number(c) ? 'green' : ''"
                  class="ma-1"
                  style="border-radius: 5pt"
                >
                  <v-list-item @click="onSelectChild(Number(c))">
                    <v-list-item-content>
                      <div>
                        {{ child.label }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
            <template v-if="kChild">
              <div class="my-2"><v-divider class="success" style="height: 2.5px; max-height: 2.5px"/></div>
              <div class="my-4">
                <span class="blue--text body-1" style="font-size: 18pt">
                  {{ mLaporan[2]['children'][kChild]['desc'] }}
                </span>
                <v-divider class="blue" style="height: 2.5px; max-height: 2.5px" />
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="6" v-if="[1].includes(kChild)">
                  <span class="grey--text">Tanggal Pelaksanaan</span>
                  <div class="body-1">{{ $localDate($getDeepObj(detail, `${kLaporan}.tgl_monev`)) }}</div>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="[1].includes(kChild)">
                  <span class="grey--text">Moda Penyelenggara IHT</span>
                  <div class="body-1">
                    <v-chip class="blue white--text" small>
                      {{ $getDeepObj(detail, `${kLaporan}.m_monev_moda_psp.data.keterangan`) }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="[1].includes(kChild)">
                  <span class="grey--text">Sasaran (Orang)</span>
                  <div>
                    <v-divider class="primary my-1" />
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="4">
                        <span class="primary--text">Jumlah Guru Mapel</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_mapel`) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="primary--text">Jumlah Guru BK</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_bk`) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" v-if="$getDeepObj(detail, `${kLaporan}.jml_guru_kejuruan`)">
                        <span class="primary--text">Jumlah Guru Kejuruan</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_kejuruan`) }}</div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="[1].includes(kChild)">
                  <span class="grey--text">Undangan yang hadir (Orang)</span>
                  <div>
                    <v-divider class="primary my-1" />
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="4">
                        <span class="primary--text">Perwakilan UPT</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_upt`) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="primary--text">Perwakilan Dinas</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_dinas`) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="primary--text">Perwakilan Pengawas</span>
                        <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_pengawas`) }}</div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[1].includes(kChild)">
                  <span class="grey--text">Kendala serta hal yang perlu diperbaiki dalam proses pelaksanaan IHT</span>
                  <div v-html="getInstrumen(2)" class="body-1"></div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[1].includes(kChild)">
                  <span class="grey--text">Hal baik yang sudah terjadi selama pelaksanaan IHT</span>
                  <div v-html="getInstrumen(3)" class="body-1"></div>
                </v-col>
                <v-col cols="12" class="pb-0" v-if="[4].includes(kChild)">
                  <h2>Bagian Umpan Balik Proses Pelaksanaan IHT</h2>
                  <div class="body-2">(Hasil olahan lembar evaluasi yang diisi oleh peserta IHT)</div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[4].includes(kChild)">
                  <span class="grey--text">
                    Secara garis besar, deskripsikan bagaimana persepsi peserta terhadap pengajar IHT
                  </span>
                  <div v-html="getInstrumen(4)" class="body-1"></div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[4].includes(kChild)">
                  <span class="grey--text">
                    Secara garis besar, bagaimana persepsi peserta terhadap ketepatan perangkat ajar yang digunakan
                    dalam IHT dalam membantu pemahaman mereka?
                  </span>
                  <div v-html="getInstrumen(5)" class="body-1"></div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[4].includes(kChild)">
                  <span class="grey--text">
                    Apakah materi IHT yang disampaikan dapat dipahami dan menjawab permasalahan di tingkat satuan
                    pendidikan/ sekolah?
                  </span>
                  <div v-html="getInstrumen(6)" class="body-1"></div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[1].includes(kChild)">
                  <span class="grey--text">Foto Kegiatan</span>
                  <div>
                    <v-row>
                      <v-col cols="12" sm="12" md="4" v-if="getPhoto(1)">
                        <v-img class="my-2" :src="getPhoto(1)" width="300px"></v-img>
                        <span class="body-1 text-center">Penutup Kegiatan</span>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" v-if="getPhoto(2)">
                        <v-img class="my-2" :src="getPhoto(2)" width="300px"></v-img>
                        <span class="body-1 text-center">Pelaksanaan Kegiatan</span>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" v-if="getPhoto(3)">
                        <v-img class="my-2" :src="getPhoto(3)" width="300px"></v-img>
                        <span class="body-1 text-center">Pembukaan Kegiatan</span>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[5].includes(kChild)">
                  <div>
                    <v-row>
                      <v-col cols="12" sm="12" md="8">
                        <h3>Dokumentasi Presensi peserta selama proses kegiatan IHT</h3>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-btn
                          depressed
                          small
                          color="primary"
                          class="mb-1"
                          :href="getPhoto(4)"
                          target="_blank"
                          :disabled="!getPhoto(4)"
                        >
                          Lihat Dokumen
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="8">
                        <h3>Dokumentasi kuitansi konsumsi selama proses kegiatan IHT</h3>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-btn
                          depressed
                          small
                          color="primary"
                          class="mb-1"
                          :href="getPhoto(5)"
                          target="_blank"
                          :disabled="!getPhoto(5)"
                        >
                          Lihat Dokumen
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" v-if="[2].includes(kChild)">
                  <h2>Rekapitulasi pre test dan post test peserta IHT</h2>
                  <div class="body-2 mb-3">Bisa ditambahkan sesuai dengan kebutuhan max 25 guru</div>
                  <v-row
                    v-for="(peserta, p) in $getDeepObj(detail, `${kLaporan}.psp_monev_pesertas.data`) || []"
                    :key="p"
                  >
                    <v-col cols="12" sm="12" md="3">
                      <span class="label--text">Nama Peserta</span>
                      <div class="blue--text body-1">{{ $getDeepObj(peserta, 'ptk.data.nama') || '' }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                      <span class="label--text">No. UKG</span>
                      <div class="font-weight-bold body-1">{{ $getDeepObj(peserta, 'ptk_id') || '' }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                      <span class="label--text"><i>Skor Pre Test</i></span>
                      <div class="body-1">{{ $getDeepObj(peserta, 'n_pretest') || '' }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                      <span class="label--text"><i>Skor Post Test</i></span>
                      <div class="body-1">{{ $getDeepObj(peserta, 'n_posttest') || '' }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-divider />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" v-if="[3].includes(kChild)">
                  <div class="body-2 mb-3">
                    Berikut adalah <b>data</b> instrumen berikut berdasarkan kategori
                    <b>Sangat Tidak Setuju, Tidak Setuju,</b> dan <b>Sangat Setuju</b>
                  </div>

                  <template v-for="(rekap, r) in mRekap">
                    <div class="container my-3" :key="r">
                      <div class="body-1 black--text font-weight-bold">{{ rekap.label }}</div>
                      <v-card outlined>
                        <v-card-text>
                          <div v-for="(child, c) in rekap.children" :key="c">
                            <div class="primary--text body-1 font-weight-bold">{{ `${child.label}` }}</div>
                            <v-row class="my-2 black--text" v-for="item in Object.keys(child.items)" :key="item">
                              <v-col cols="12" sm="12" md="6">
                                {{ `${Number(item)}. ${child.items[item]}` }}
                              </v-col>
                              <v-col cols="12" sm="12" md="6">
                                <v-row>
                                  <v-col cols="12" sm="12" md="3" class="pa-0 text-center">
                                    <span class="red--text">Sangat Tidak Setuju</span>
                                    <div class="body-1 font-weight-medium">
                                      {{ $getDeepObj(mFeedbacks, `${item}.n1`) || '0' }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="3" class="pa-0 text-center">
                                    <span class="orange--text">Tidak Setuju</span>
                                    <div class="body-1 font-weight-medium">
                                      {{ $getDeepObj(mFeedbacks, `${item}.n2`) || '0' }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="3" class="pa-0 text-center">
                                    <span class="blue--text">Setuju</span>
                                    <div class="body-1 font-weight-medium">
                                      {{ $getDeepObj(mFeedbacks, `${item}.n3`) || '0' }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="3" class="pa-0 text-center">
                                    <span class="success--text">Sangat Setuju</span>
                                    <div class="body-1 font-weight-medium">
                                      {{ $getDeepObj(mFeedbacks, `${item}.n4`) || '0' }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" sm="12" md="12">
                                <v-divider />
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </template>
                </v-col>
                <v-col cols="12" class="pb-0" v-if="[4].includes(kChild)">
                  <h2>Hambatan dan Dukungan</h2>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="[4].includes(kChild)">
                  <span class="grey--text">
                    Jenis Hambatan apa yang paling sering ditemui peserta pelatihan selama proses IHT?
                  </span>
                  <div class="body-1">
                    <ul>
                      <template v-for="(item, i) in getOpsi(7)">
                        <li :key="i">
                          {{ $getDeepObj(item, 'm_monev_opsi_psp.data.keterangan') || '' }}
                          <span v-if="[9, 14].includes(item.k_monev_opsi_psp)">
                            - {{ $getDeepObj(item, 'catatan') || '' }}
                          </span>
                        </li>
                      </template>
                    </ul>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="[4].includes(kChild)">
                  <span class="grey--text">
                    Jenis Dukungan yang paling banyak diperlukan oleh peserta IHT agar proses IHT semakin baik?
                  </span>
                  <div class="body-1">
                    <ul>
                      <template v-for="(item, i) in getOpsi(8)">
                        <li :key="i">
                          {{ $getDeepObj(item, 'm_monev_opsi_psp.data.keterangan') || '' }}
                          <span v-if="[14].includes(item.k_monev_opsi_psp)">
                            - {{ $getDeepObj(item, 'catatan') || '' }}
                          </span>
                        </li>
                      </template>
                    </ul>
                  </div>
                </v-col>
              </v-row>
            </template>
          </template>
          <template v-else>
            <v-row>
              <v-col cols="12" sm="12" md="6" v-if="[1, 2, 3].includes(kLaporan)">
                <span class="grey--text">Tanggal Pelaksanaan</span>
                <div class="body-1">{{ $localDate($getDeepObj(detail, `${kLaporan}.tgl_monev`)) }}</div>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="[1, 2, 3].includes(kLaporan)">
                <span class="grey--text">Moda Penyelenggara IHT</span>
                <div class="body-1">
                  <v-chip class="blue white--text" small>
                    {{ $getDeepObj(detail, `${kLaporan}.m_monev_moda_psp.data.keterangan`) }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="[1, 3].includes(kLaporan)">
                <span class="grey--text">Sasaran (Orang)</span>
                <div>
                  <v-divider class="primary my-1" />
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="4">
                      <span class="primary--text">Jumlah Guru Mapel</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_mapel`) }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <span class="primary--text">Jumlah Guru BK</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_bk`) }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" v-if="$getDeepObj(detail, `${kLaporan}.jml_guru_kejuruan`)">
                      <span class="primary--text">Jumlah Guru Kejuruan</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_guru_kejuruan`) }}</div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="[1, 3].includes(kLaporan)">
                <span class="grey--text">Undangan yang hadir (Orang)</span>
                <div>
                  <v-divider class="primary my-1" />
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="4">
                      <span class="primary--text">Perwakilan UPT</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_upt`) }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <span class="primary--text">Perwakilan Dinas</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_dinas`) }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <span class="primary--text">Perwakilan Pengawas</span>
                      <div class="body-1">{{ $getDeepObj(detail, `${kLaporan}.jml_hadir_pengawas`) }}</div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[1, 2, 3].includes(kLaporan)">
                <span class="grey--text">Latar Belakang dan Tujuan Kegiatan</span>
                <div v-html="getInstrumen(1)" class="body-1"></div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[1, 2, 3].includes(kLaporan)">
                <span class="grey--text">Kendala serta hal yang perlu diperbaiki dalam proses pelaksanaan IHT</span>
                <div v-html="getInstrumen(2)" class="body-1"></div>
              </v-col>
              <v-col cols="12" class="pb-0" v-if="[3].includes(kLaporan)">
                <h2>Bagian Umpan Balik Proses Pelaksanaan IHT</h2>
                <div class="body-2">(Hasil olahan lembar evaluasi yang diisi oleh peserta IHT)</div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[3].includes(kLaporan)">
                <span class="grey--text">
                  Secara garis besar, deskripsikan bagaimana persepsi peserta terhadap pengajar IHT
                </span>
                <div v-html="getInstrumen(4)" class="body-1"></div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[3].includes(kLaporan)">
                <span class="grey--text">
                  Secara garis besar, bagaimana persepsi peserta terhadap ketepatan perangkat ajar yang digunakan dalam
                  IHT dalam membantu pemahaman mereka?
                </span>
                <div v-html="getInstrumen(5)" class="body-1"></div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[3].includes(kLaporan)">
                <span class="grey--text">
                  Apakah materi IHT yang disampaikan dapat dipahami dan menjawab permasalahan di tingkat satuan
                  pendidikan/ sekolah?
                </span>
                <div v-html="getInstrumen(6)" class="body-1"></div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[1, 2].includes(kLaporan)">
                <span class="grey--text">Hal baik yang sudah terjadi selama pelaksanaan IHT</span>
                <div v-html="getInstrumen(3)" class="body-1"></div>
              </v-col>
              <v-col cols="12" class="pb-0" v-if="[3].includes(kLaporan)">
                <h2>Hambatan dan Dukungan</h2>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="[3].includes(kLaporan)">
                <span class="grey--text">
                  Jenis Hambatan apa yang paling sering ditemui peserta pelatihan selama proses IHT?
                </span>
                <div class="body-1">
                  <ul>
                    <template v-for="(item, i) in getOpsi(7)">
                      <li :key="i">
                        {{ $getDeepObj(item, 'm_monev_opsi_psp.data.keterangan') || '' }}
                        <span v-if="[9, 14].includes(item.k_monev_opsi_psp)">
                          - {{ $getDeepObj(item, 'catatan') || '' }}
                        </span>
                      </li>
                    </template>
                  </ul>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="[3].includes(kLaporan)">
                <span class="grey--text">
                  Jenis Dukungan yang paling banyak diperlukan oleh peserta IHT agar proses IHT semakin baik?
                </span>
                <div class="body-1">
                  <ul>
                    <template v-for="(item, i) in getOpsi(8)">
                      <li :key="i">{{ $getDeepObj(item, 'm_monev_opsi_psp.data.keterangan') || '' }}</li>
                    </template>
                  </ul>
                </div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[1, 2].includes(kLaporan)">
                <span class="grey--text">Dokumentasi Kegiatan</span>
                <div>
                  <v-row>
                    <v-col cols="12" sm="12" md="4" v-if="getPhoto(1)">
                      <v-img class="my-2" :src="getPhoto(1)"></v-img>
                      <span class="body-1">Foto Kegiatan</span>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" v-if="getPhoto(2)">
                      <v-img class="my-2" :src="getPhoto(2)"></v-img>
                      <span class="body-1">Foto Kegiatan</span>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" v-if="getPhoto(3)">
                      <v-img class="my-2" :src="getPhoto(3)"></v-img>
                      <span class="body-1">Foto Kegiatan</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="12" v-if="[4].includes(kLaporan)">
                <div>
                  <v-row>
                    <v-col cols="12" sm="12" md="8">
                      <h3>Dokumentasi Presensi peserta selama proses kegiatan IHT</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-btn
                        depressed
                        small
                        color="primary"
                        class="mb-1"
                        :href="getPhoto(4)"
                        target="_blank"
                        :disabled="!getPhoto(4)"
                      >
                        Lihat Dokumen
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="8">
                      <h3>Dokumentasi kuitansi konsumsi selama proses kegiatan IHT</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-btn
                        depressed
                        small
                        color="primary"
                        class="mb-1"
                        :href="getPhoto(5)"
                        target="_blank"
                        :disabled="getPhoto(5)"
                      >
                        Lihat Dokumen
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-list-item-content>
        <v-list-item-content class="py-0 mt-3" v-else>
          <v-row>
            <v-col cols="12" class="text-center grey--text">
              <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
              <h2>Laporan IHT Berkala Tidak Tersedia</h2>
              <div class="body-2">
                Hal ini dikarenakan pihak terkait belum mengirimkan
                {{ $getDeepObj(detail, `${kLaporan}.m_monev_laporan_psp.data.keterangan`) }}
              </div>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FormPreviewIht',
  props: {
    detail: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      kLaporan: null,
      kChild: null,
    };
  },
  computed: {
    mLaporan() {
      return [
        {
          text: 'Laporan IHT 1',
          value: 1,
          icon: 'mdi-file-document',
          children: false,
        },
        {
          text: 'Laporan IHT 2',
          value: 2,
          icon: 'mdi-file-document',
          children: false,
        },
        {
          text: 'Laporan IHT 3',
          value: 3,
          icon: 'mdi-file-document',
          children: {
            1: { label: 'A. Laporan Umum', desc: 'A. Laporan Umum' },
            2: { label: 'B. Evaluasi Peserta', desc: 'B. Evaluasi Peserta' },
            3: { label: 'C. Evaluasi IHT', desc: 'C. Rekapitulasi Evaluasi Penyelenggaraan IHT dari Peserta' },
            4: { label: 'D. Umpan Balik', desc: 'D. Umpan Balik' },
            5: { label: 'E. Dok Administrasi', desc: 'E. Dok Administrasi' },
          },
        },
      ];
    },

    mRekap() {
      return [
        {
          label: 'I. Instrumen Umpan Balik Pengajar IHT',
          children: [
            {
              label: 'Persepsi Terkait Metode IHT',
              items: {
                1: 'Penyampaian materi yang diberikan menarik',
                2: 'Pengajar menguasai materi IHT',
                3: 'Pengajar mampu menyampaikan materi sehingga mudah dipahami.',
                4: 'Pengajar memberikan umpan balik (feedback) yang membantu peserta untuk lebih memahami materi yang diajarkan',
                5: 'Pengajar memberikan kesempatan bertanya dan berdiskusi.',
                6: 'Pengajar melakukan asesmen yang dilakukan oleh pengajar sesuai dengan tujuan IHT',
                7: 'Pengajar memiliki manajemen waktu pembelajaran yang baik',
                8: 'Pengajar mampu menjawab pertanyaan-pertanyaan yang diajukan oleh peserta IHT',
                9: 'Pengajar mampu memberikan motivasi kepada peserta IHT',
              },
            },
          ],
        },
        {
          label: 'II. Instrumen Umpan Balik Proses Penyelenggaraan IHT',
          children: [
            {
              label: 'Persepsi terkait Metode IHT',
              items: {
                10: 'Metode kombinasi antara synchronous (terstruktur) dan asynchronous (mandiri) dapat secara efektif meningkatkan pemahaman dan keterampilan.',
                11: 'Secara umum, durasi pelaksanaan IHT dengan metode terstruktur (synchronous) efisien.',
                12: 'Secara umum, durasi pelaksanaan IHT dengan metode mandiri (asynchronous) efisien.',
                13: 'Kegiatan praktik dalam pelaksanaan IHT memiliki kesesuaian dengan konsep/teori yang diajarkan.',
                14: 'Teknik penyampaian materi melalui eksplorasi konsep yang dilanjutkan dengan diskusi (pembelajaran alur merdeka) memudahkan saya dalam memahami materi IHT',
              },
            },
            {
              label: 'Perangkat Ajar IHT',
              items: {
                15: 'Panduan IHT yang diberikan berisi informasi yang dibutuhkan oleh peserta',
                16: 'Modul IHT mudah untuk diakses/diunduh.',
                17: 'Platform pembelajaran yang digunakan untuk proses IHT mudah untuk digunakan (user friendly).',
                18: 'Platform pembelajaran IHT membantu saya memahami materi.',
                19: 'Platform pembelajaran IHT membantu saya mengikuti keseluruhan proses IHT.',
                20: 'Platform pembelajaran IHT memberikan informasi tentang umpan balik (feedback) dari pengajar sehingga membantu meningkatkan pengetahuan dan keterampilan saya.',
              },
            },
            {
              label: 'Substansi/Materi IHT',
              items: {
                21: 'Secara umum, materi IHT cukup mudah dipahami',
                22: 'Materi IHT menyiapkan saya dalam meningkatkan kualitas pembelajaran kepada peserta didik',
                23: 'Materi IHT dapat menjawab permasalahan di tingkat satuan pendidikan',
              },
            },
          ],
        },
      ];
    },

    mFeedbacks() {
      const feedback =
        (this.detail &&
          this.detail[3] &&
          this.detail[3]['psp_monev_feedbacks'] &&
          this.detail[3]['psp_monev_feedbacks']['data']) ||
        [];

      return this.$arrToObj(feedback, 'k_monev_feedback_psp') || {};
    },
  },
  methods: {
    getInstrumen(kInstrumen) {
      const laporan = this.detail[this.kLaporan] || {};
      const instrumen = (this.$getDeepObj(laporan, 'psp_monev_instrumens.data') || []).filter((ins) => {
        return +ins.k_monev_instrumen_psp === +kInstrumen;
      });

      return (instrumen[0] && instrumen[0]['catatan']) || '';
    },

    getOpsi(kInstrumen) {
      const laporan = this.detail[this.kLaporan] || {};
      const instrumen = (this.$getDeepObj(laporan, 'psp_monev_instrumens.data') || []).filter((ins) => {
        return +ins.k_monev_instrumen_psp === +kInstrumen;
      });

      return instrumen || [];
    },

    getPhoto(kBerkas) {
      const laporan = this.detail[this.kLaporan] || {};
      const berkas = (this.$getDeepObj(laporan, 'psp_monev_berkases.data') || []).filter((ins) => {
        return +ins.k_monev_berkas_psp === +kBerkas;
      });

      return (berkas[0] && berkas[0]['url_berkas']) || '';
    },

    onSelectLaporan(kLaporan) {
      this.kLaporan = kLaporan;
    },

    onSelectChild(kChild) {
      this.kChild = kChild;
    },
  },
};
</script>

<style scoped></style>
